let CREDIT_TYPE_ICON = {
    Switch: "switch.png",
    PC: "pc.png",
    YouTube: "youtube.png",
    VR: "vr.png",
    Phone: "phone.png",
    変更なし: "none.png",
};
/*let CREDIT_TYPE_ICON = {
    Switch: "🎮",
    PC: "🖥️",
    YouTube: "▶️",
    VR: "🥽",
    Phone: "📱",
    変更なし: "🟰",
};*/

export default function CreditType({
  type
}) {
  let icon = CREDIT_TYPE_ICON[type];

  return (
    <span className="credit_type">{
      !icon ? type : (<>
        <div className="icon"><img src={"/"+icon} width="32px" height="32px"/></div>
        <div className="icon_detail">{type}</div>
      </>)
    }</span>
  );
}
